// extracted by mini-css-extract-plugin
export var Social = "Social-module--Social--ER6Uf";
export var Link = "Social-module--Link--LWBiw";
export var arrowLeft = "Social-module--arrowLeft--tYcoy";
export var arrowRight = "Social-module--arrowRight--cY1+-";